import { useLocation } from 'react-router-dom';

const useIsLeagueDesk = () => {
  const { pathname } = useLocation();
  return pathname.toLowerCase().includes('/leagues');
};

export default useIsLeagueDesk;
